import { SvgIcon, SxProps, Theme } from "@mui/material";

export default function PlusIconSvg({ sx }: { sx?: SxProps<Theme> }) {
    return (
        <SvgIcon
            viewBox="0 0 21 20"
            sx={{ width: 21, height: 20, fill: "none", ...sx }}
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_36_9861"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="20"
            >
                <rect x="0.5" width="20" height="20" fill="currentColor" />
            </mask>
            <g mask="url(#mask0_36_9861)">
                <path
                    d="M9.66669 10.8333H4.66669V9.16667H9.66669V4.16667H11.3334V9.16667H16.3334V10.8333H11.3334V15.8333H9.66669V10.8333Z"
                    fill="currentColor"
                />
            </g>
        </SvgIcon>
    );
}
